import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useBehaviorSubject } from '@euler/utils/hooks/useBehaviorSubject';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors } from '../../../../../ai-suite/theme';
import { LiveCoachingEdge } from '../../../functions/useCoachingEdge';
import { ReactionSlot } from './ReactionSlot';
import { SkillBar } from './SkillBar';

/**
 * Beside the dialogue on wider screens: the coach's reaction, the star cap
 * after a critical error, and every area observed so far.
 */
export const CoachingEdge = memo(({ edge }: { edge: LiveCoachingEdge }) => {
  const { rpx } = useResponsiveContext();
  const [areas] = useBehaviorSubject(edge.areas$);
  const [reaction] = useBehaviorSubject(edge.reaction$);
  const [capped] = useBehaviorSubject(edge.capped$);
  return (
    <View style={{ width: rpx(260), padding: rpx(16), gap: rpx(14) }}>
      <View style={{ minHeight: rpx(32), justifyContent: 'center' }}>
        <ReactionSlot reaction={reaction} />
      </View>
      {capped ? (
        <Typography.Text size={rpx(11)} color={aiColors.destructive}>
          ★ 这次最高一星
        </Typography.Text>
      ) : null}
      <View style={{ gap: rpx(8) }}>
        {areas.map(bar => (
          <SkillBar key={bar.area} bar={bar} dimmed={capped} />
        ))}
      </View>
    </View>
  );
});
